import { createRef } from "react";
import HBConfirm from "../../HBModal/confirm";
import VerifyInput from "../VerifyInput";

/**
 * 滑块验证弹框
 * @param {Object} props
 * @param {string} props.title 标题 弹框的提示内容, 也有默认
 * @param {string} props.id id当一个页面会同时存在多个滑动验证时，请取一个不会冲突的id
 * @param {string} props.type 验证场景，默认 other， 其他场景有：regiseter reset
 * @param {()=>void} props.onOk 验证场景，默认 other， 其他场景有：regiseter reset
 * @example  VerifyConfirm({ captchakey: result.captchakey });
 */
export default function VerifyAction({
  title = "请完成滑动验证",
  id = "action-nc",
  type = "other",
  onOk,
}) {
  let verifyRef = createRef();
  const confirm = HBConfirm.open({
    title: "提示",
    visibleControl: true,
    content: (
      <div>
        <div style={{ paddingBottom: "16px" }}>{title}</div>
        <VerifyInput
          id={id}
          ref={verifyRef}
          type={type}
          onOk={(data) => {
            onOk(data);
            confirm.destroy();
          }}
        />
      </div>
    ),
    hideOkBtn: true,
    hideCancelBtn: true,
  });

  return confirm;
}
